import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { DATA_ALREADY_EXIST, PRODUCT_SKU_EXIST } from '../../utility/ResponseConstant'
import { useNavigate } from 'react-router-dom'

const InteractorProductFormAction = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [productLoading, setProductLoading] = useState(false)
  const deleteProduct = useCallback(
    (payload, callback) => {
      let requestPayload = { ...payload }
      setProductLoading(true)
      ApiService.jsonRequest('/product-item/delete', requestPayload, (response) => {
        setProductLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_deleted`),
            timer: false,
          })
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
        callback()
      })
    },
    [t],
  )

  const addProduct = useCallback(
    (payload) => {
      let productPayload = { ...payload }
      // setProductLoading(true)
      ApiService.jsonRequest('/product-item/create', productPayload, (response) => {
        setProductLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
          })
          navigate('/product')
        } else {
          if (response.messages === DATA_ALREADY_EXIST || response.messages === PRODUCT_SKU_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [navigate, t],
  )

  const updateProduct = useCallback(
    (payload) => {
      let productPayload = { ...payload }
      setProductLoading(true)
      ApiService.jsonRequest('/product-item/update', productPayload, (response) => {
        setProductLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_updated`),
            timer: 2000,
          })
          navigate('/product')
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [navigate, t],
  )

  return { addProduct, deleteProduct, updateProduct, productLoading }
}

export default InteractorProductFormAction
